import { render, staticRenderFns } from "./Meal_plans.vue?vue&type=template&id=ee852b78&scoped=true&"
import script from "./Meal_plans.vue?vue&type=script&lang=js&"
export * from "./Meal_plans.vue?vue&type=script&lang=js&"
import style0 from "./Meal_plans.vue?vue&type=style&index=0&id=ee852b78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee852b78",
  null
  
)

export default component.exports